import { Component, HostListener, OnInit } from '@angular/core';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-web-footer',
  templateUrl: './web-footer.component.html',
  styleUrl: './web-footer.component.scss'
})
export class WebFooterComponent implements OnInit {

  public currentYear: string = DateTime.now().toFormat('y');
  public showScrollTop: boolean = false;

  constructor() { }

  ngOnInit(): void { }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.showScrollTop = window.scrollY > 300;
  }

  scrollToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
